module.exports = "/_next/static/images/4b3bdf7050d4776197676258259f99f6-nubank-shooting-hands-diversity@3x.jpg";